<nav class="navbar navbar-expand-md navbar-dark bg-transparent card-glass shadow-lg">
  <div class="container-fluid">
    <a class="navbar-brand" (click)="clearStorage()" title="logout">
      <img src="../../../assets/images/logout.png" alt="logout">
    </a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent"
      aria-controls="navbarContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarContent">
      <div class="d-md-none w-100">
        <ul class="navbar-nav flex-row justify-content-between w-100">
          <li class="nav-item">
            <a title="Chat" class="nav-link active" aria-current="page" href="/prechat">
              <i class="bi bi-chat-dots-fill"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="toggleLocationModal(); closeNavbar();" title="Set location range">
              <i class="bi bi-geo-alt-fill"></i>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="toggleGenderModal();closeNavbar();" title="Set gender filter">
              <i class="bi bi-gender-ambiguous"></i>
            </a>
          </li>
          <li class="nav-item position-relative">
            <a class="nav-link notification-icon" (click)="toggleNotifications();closeNavbar();" title="Notifications">
              <i class="bi bi-bell-fill fs-5"></i>
              @if (notificationCount > 0) {
                <span class="notification-badge">
                  {{ notificationCount > 99 ? '99+' : notificationCount }}
                </span>
              }
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link clickable" (click)="toggleSettingsModal();closeNavbar();" title="Settings">
              <i class="bi bi-gear-fill"></i>
            </a>
          </li>
        </ul>
        <form class="d-flex mx-2" role="search">
          <div class="input-group">
            <input
              class="form-control bg-transparent text-white border-secondary"
              type="search"
              placeholder="Search..."
              aria-label="Search"
              [ngModel]="searchTerm"
              (ngModelChange)="onSearchInput($event)"
              name="searchInput"
              />
              <button title="Search" class="btn btn-outline-info" type="button">
                <i class="bi bi-search"></i>
              </button>

            </div>
          </form>

        </div>

        <div class="d-none d-md-flex w-100 align-items-center navdesk">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <a class="nav-link active" aria-current="page" href="/prechat" title="Chat">
                <i class="bi bi-chat-dots-fill me-1"></i>Chats
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link clickable" (click)="toggleLocationModal()" title="Set location range">
                <i class="bi bi-geo-alt-fill me-1"></i>Location
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link clickable" (click)="toggleGenderModal()" title="Set gender filter">
                <i class="bi bi-gender-ambiguous me-1"></i>Gender
              </a>
            </li>
          </ul>
          <form class="d-flex mx-2" role="search">
            <div class="input-group">
              <input class="form-control bg-transparent text-white border-secondary" type="search" placeholder="Search..."
                aria-label="Search" [ngModel]="searchTerm" (ngModelChange)="onSearchInput($event)"
                name="searchInputMobile" />

                <button title="Search" class="btn btn-outline-info" type="submit">
                  <i class="bi bi-search"></i>
                </button>
              </div>
            </form>
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link notification-icon" (click)="toggleNotifications()" title="Notifications">
                  <i class="bi bi-bell-fill fs-5"></i>
                  @if (notificationCount > 0) {
                    <span class="notification-badge">
                      {{ notificationCount > 99 ? '99+' : notificationCount }}
                    </span>
                  }
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link clickable" (click)="toggleSettingsModal()" title="Settings">
                  <i class="bi bi-gear-fill"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>